import { useEffect, useState } from "react";

export default function useReportListScroll(containerRef, listRef, items, limit = 10) {
  const [maxHeight, setMaxHeight] = useState(null);

  useEffect(() => {
    const container = containerRef.current;
    const list = listRef.current;
    if (!container || !list || !items || items.length <= limit) {
      setMaxHeight(null);
      return undefined;
    }
    const visibleItems = Array.from(list.children).slice(0, limit);
    if (visibleItems.length < limit) return undefined;
    const measure = () => {
      const firstItem = visibleItems[0].getBoundingClientRect();
      const lastItem = visibleItems[visibleItems.length - 1].getBoundingClientRect();
      if (lastItem.bottom <= firstItem.top) return;
      const borderBottom = parseFloat(window.getComputedStyle(container).borderBottomWidth) || 0;
      setMaxHeight(Math.ceil(lastItem.bottom - container.getBoundingClientRect().top + container.scrollTop + borderBottom));
    };
    let measureFrame;
    const scheduleMeasure = () => {
      window.cancelAnimationFrame(measureFrame);
      measureFrame = window.requestAnimationFrame(measure);
    };
    measure();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(scheduleMeasure);
    visibleItems.forEach((item) => observer?.observe(item));
    window.addEventListener("resize", scheduleMeasure);
    return () => {
      observer?.disconnect();
      window.cancelAnimationFrame(measureFrame);
      window.removeEventListener("resize", scheduleMeasure);
    };
  }, [containerRef, listRef, items, limit]);

  return maxHeight || undefined;
}
